import { useMemo } from "react";
import { useHasOrgContext } from "../../auth/useHasOrgContext";
import type { WizardStepPath as StepPath } from "../../wizard/wizardStepPaths";
import { urls } from "../../../urls";
import type { BidStep } from "./bidWizardSteps";
import type { RequestStep } from "./requestWizardSteps";

export interface PortalEventUrls {
  list: string;
  view: {
    go: (eventId: string) => string;
    question: (eventId: string, questionId: string) => string;
    announcement: (eventId: string, announcementId: string) => string;
  };
  bid: { edit: { go: (eventId: string, bidId: string) => Record<BidStep, StepPath> } };
  privateBid: { edit: { go: (eventId: string, bidId: string) => string } };
  request: { edit: { go: (eventId: string, requestId: string) => Record<RequestStep, StepPath> } };
}

export const usePortalEventUrls = (): PortalEventUrls => {
  const hasOrgContext = useHasOrgContext();
  return useMemo(
    () =>
      hasOrgContext
        ? {
            list: urls.app.supplier.procurements,
            view: urls.app.supplier.procurement,
            bid: urls.app.supplier.bid,
            privateBid: urls.app.supplier.privateBid,
            request: urls.app.supplier.request,
          }
        : {
            list: urls.portal.list,
            view: urls.portal.view,
            bid: urls.portal.bid,
            privateBid: urls.portal.privateBid,
            request: urls.portal.request,
          },
    [hasOrgContext],
  );
};
